<ssc-person [name]="getFirstNameOrFallback$() | async" [icon]="getIcon$() | async"></ssc-person>
<visana-lib-form-field
  [error]="validatorService.getErrorMessage(formGroup.controls.firstName, validateForm)"
  [inputId]="'firstName-' + person.personId"
  label="{{ 'COMMON.FIRST_NAME' | translate }}"
>
  <input
    [id]="'firstName-' + person.personId"
    sscCapitalize
    data-cy="input-first-name"
    [formControl]="formGroup.controls.firstName"
    placeholder="{{ 'COMMON.FIRST_NAME' | translate }}"
    type="text"
  />
</visana-lib-form-field>
<visana-lib-form-field
  [error]="validatorService.getErrorMessage(formGroup.controls.lastName, validateForm)"
  [inputId]="'lastName-' + person.personId"
  label="{{ 'COMMON.LAST_NAME' | translate }}"
>
  <input
    [id]="'lastName-' + person.personId"
    sscCapitalize
    data-cy="input-last-name"
    [formControl]="formGroup.controls.lastName"
    placeholder="{{ 'COMMON.LAST_NAME' | translate }}"
    type="text"
  />
</visana-lib-form-field>
<visana-lib-date-picker
  [inputId]="'dateOfBirth-' + person.personId"
  label="{{ 'COMMON.DATE_OF_BIRTH' | translate }}"
  data-cy="input-birthday"
  [formControl]="formGroup.controls.dateOfBirth"
></visana-lib-date-picker>

<ng-container *ngIf="formGroup.controls.email && formGroup.controls.phone">
  <h3 class="headline-5">{{ 'COMMON.CONTACT' | translate }}</h3>
  <visana-lib-form-field
    [error]="validatorService.getEmailErrorMessage(formGroup.controls.email, validateForm)"
    [inputId]="'email-' + person.personId"
    label="{{ 'COMMON.EMAIL' | translate }}"
  >
    <input
      [id]="'email-' + person.personId"
      data-cy="input-email"
      [formControl]="formGroup.controls.email"
      placeholder="{{ 'COMMON.EMAIL' | translate }}"
      type="email"
    />
  </visana-lib-form-field>
  <visana-lib-form-field
    [error]="validatorService.getErrorMessage(formGroup.controls.phone, validateForm)"
    [inputId]="'phone-' + person.personId"
    label="{{ 'COMMON.PHONE_NR' | translate }}"
  >
    <input
      [id]="'phone-' + person.personId"
      data-cy="input-phone"
      [formControl]="formGroup.controls.phone"
      placeholder="{{ 'COMMON.PHONE_NR' | translate }}"
      type="tel"
    />
  </visana-lib-form-field>
</ng-container>
